// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class Image {
  public id: string;

  public url: string;

  public position: number;

  constructor(id: string, url: string, position: number) {
    this.id = id;
    this.url = url;
    this.position = position;
  }
}
